import { Box, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { variants } from '../../../variants/variants';
import UserAvatar from '../../../common/UserAvatar';
const ProfileCard = ({ content, handleProfileClick, style = {} }) => {
  const { empCode } = useParams();
  const currentProfile = empCode === content.empCode;
  console.log('content', content)
  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      style={style}
      sx={{
        p: 1,
        borderBottom: currentProfile ? 1 : 0,
        borderColor: 'divider',
        cursor: 'default',
        color: currentProfile ? 'white' : 'inherit',
        background: currentProfile ? '#004BAE' : 'inherit',
        borderRadius: variants.boxRadius.SIDEBAR,
        '&:hover': { backgroundColor: currentProfile ? '#004BAE' : '#EEF7FF' },
      }}
      onClick={() => handleProfileClick(content.empCode)}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', zIndex: 1 }}>
        <UserAvatar showStatus={true} size={35} src={content?.employeePhotoPath} empCode={content?.empCode} />
        <Box sx={{ ml: 1 }}>
          <Typography fontWeight={currentProfile ? '600' : 'normal'} sx={{ fontSize: variants.BODY }}>
            {!content.empName ? content.firstName+" "+content.middleName+" "+content.lastName : content.empName }
          </Typography>
          <Typography fontWeight={currentProfile ? '600' : 'normal'} sx={{ fontSize: variants.TINY }}>
            {content.shortNameofDesignation}
          </Typography>
        </Box>
      </Box>
      <Box>
        <Typography fontWeight={currentProfile ? '600' : 'normal'} sx={{ fontSize: variants.TINY }}>
          {content.shortNameofBU}
        </Typography>
        {/* <Typography sx={{ fontSize: variants.TINY }}>{content.tech}</Typography> */}
      </Box>
    </Stack>
  );
};

export default ProfileCard;
